import { useSettings } from './useSettings';

/**
 * The largest request the server's PHP configuration accepts, and what that leaves
 * for a single file. A limit of 0 means there is none.
 */
export function useUploadLimit() {
  const { getSetting } = useSettings();
  const maxRequestBytes = getSetting('max_upload_size') ?? 0;

  // Files are sent base64-encoded inside the JSON body, which makes them a third larger.
  const maxFileBytes = Math.floor((maxRequestBytes * 3) / 4);

  function exceedsRequestLimit(payload: unknown): boolean {
    return maxRequestBytes > 0 && new Blob([JSON.stringify(payload)]).size > maxRequestBytes;
  }

  return {
    maxRequestBytes,
    maxFileBytes,
    exceedsRequestLimit,
  };
}
